import { AppDispatch } from '../../../../app/store';
import { TpDataContext } from '../../../../data/interfaces';
import { FORM_DATATYPES, TpAutoFormDef, promptAutoForm } from '../../../../components/auto-form-modal/AutoForm';
import { addNewTabber, updateTabberSettings } from '../../data/dashboardsSlice';
import { get_guid } from '../../helpers/misc';
import { TpDashboardContext, TpDashboardTabberDefinition } from '../interfaces';

export function promptAddTabber(
  dataContext: TpDataContext,
  dashboardContext: TpDashboardContext,
  parentId: string,
  dispatch: AppDispatch,
) {
  // const form: TpAutoFormDef = {
  //     title: "Create new tabber",
  //     fields: [
  //         {
  //             id: 'height',
  //             name: 'Height (px)',
  //             dataType: "number",
  //             startContent: 400,
  //         },
  //     ]
  // }

  // promptAutoForm(form).then((formData: any) => {
  //     dispatch(addNewTabber({ dashboardDefId: dashboardContext.dashboardDefId, parentId, id: get_guid() }))
  // }, () => { });

  dispatch(addNewTabber({ dashboardDefId: dashboardContext.dashboardDefId, parentId, id: get_guid() }));
}

export function promptTabberSettings(
  dataContext: TpDataContext,
  dashboardContext: TpDashboardContext,
  elemDef: TpDashboardTabberDefinition,
  dispatch: AppDispatch,
) {
  const form: TpAutoFormDef = {
    title: 'Tabber settings',
    fields: [
      {
        id: 'tabTitles',
        name: 'Tab titles (on separate lines)',
        dataType: FORM_DATATYPES.STRING,
        required: true,
        lineCount: 7,
        startContent: elemDef.tabTitles.join('\n'),
      },
    ],
  };

  promptAutoForm(form).then(
    (dataForm: any) => {
      const tabTitles = dataForm.tabTitles.split('\n');
      dispatch(updateTabberSettings({ dashboardDefId: dashboardContext.dashboardDefId, id: elemDef.id, tabTitles }));
    },
    () => {},
  );
}
